import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { AppVersion, menuItems } from "../../constants/GlobalConstants";

const Sidebar = ({ nav }) => {
  const { userInfo } = useSelector((state) => state.userSignIn);
  const [activeSection, setActiveSection] = useState("pills-dashboards");
  const location = useLocation();

  const hasPermission = (requiredPermissions) =>
    requiredPermissions.some((permission) =>
      userInfo?.roles?.includes(permission)
    );

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = menuItems.find((item) =>
      item.links.some((link) => link.to === currentPath)
    );
    if (matchedItem) {
      setActiveSection(matchedItem.id);
    }
  }, [location.pathname]);

  const toggleHandle = () => {
    nav.isSidebar === "wrapper"
      ? nav.setIsSidebar("wrapper toggled")
      : nav.setIsSidebar("wrapper");
  };

  const toggleMainMenu = (sectionId) => {
    setActiveSection(sectionId); 
    if (window.innerWidth > 1200) {
      nav.setIsSidebar("wrapper");
    }
  };
 

  const renderLinkIcon = (link) => {
    // Check if there's a custom icon for the link or use the default icon
    return link.customIcon ? link.customIcon : <i className={link.icon} />;
  };

  return (
    <aside className="sidebar-wrapper">
      <div className="iconmenu">
        <button onClick={toggleHandle} style={{ marginRight: "-14px" }}>
          <div className="nav-toggle-box">
            <div className="nav-toggle-icon">
              <i className="bi bi-list" />
            </div>
          </div>
        </button>
        <ul className="nav nav-pills flex-column">
          {menuItems
            .filter((item) => hasPermission(item.permissions))
            .map((item) => (
              <li
                key={item.id}
                className="nav-item"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title={item.tooltip}
              >
                <button
                  onClick={() => toggleMainMenu(item.id)}
                  className={`nav-link ${
                    activeSection === item.id ? "active" : ""
                  }`}
                  type="button"
                >
                  <i className={item.icon} />
                </button>
              </li>
            ))}
        </ul>
      </div>
      <div className="textmenu">
        <div className="brand-logo">
          <img src="/assets/images/brand-logo-2.png" width={140} alt="" />
        </div>
        <div className="tab-content">
          {menuItems
            .filter((item) => hasPermission(item.permissions))
            .map((item) => (
              <div
                key={item.id}
                className={`tab-pane fade ${
                  activeSection === item.id ? "show active" : ""
                }`}
                id={item.id}
              >
                <div className="list-group list-group-flush">
                  <div className="list-group-item">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-0">{item.title}</h5>
                    </div>
                    <small className="mb-0">{item.subtitle}</small>
                  </div>
                  {item.links
                    .filter((link) => hasPermission(link.permissions))
                    .map((link) => (
                      <Link
                        key={link.to}
                        to={link.to}
                        className="list-group-item"
                        onClick={() => {
                          setActiveSection(item.id);
                          nav.setIsSidebar("wrapper");
                        }}
                      >
                        {renderLinkIcon(link)}
                        {link.label}
                      </Link>
                    ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
